import * as favoriteNodeParser from '../../utils/favoriteNodeParser';
import folderStore from 'mini-mail-folder-store/lib/store/Store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import tryAddSingleFavoriteFolderToStore from './tryAddSingleFavoriteFolderToStore';
import { action } from 'satcheljs/lib/legacy';

/**
 * Deserialize the raw favorites data from userOptions.FavoriteNodes and load it to favorites store
 */
export default action('loadFavoriteNodesToStore')(function loadFavoriteNodesToStore() {
    const userOptions = getUserConfiguration().UserOptions;
    if (!userOptions.FavoriteNodes) {
        // Nothing to load
        return;
    }

    // Populate favorites based on the UserOptions.FavoriteNodes
    userOptions.FavoriteNodes.forEach(rawNode => {
        const parsedFolderId = favoriteNodeParser.parse(rawNode);
        tryAddSingleFavoriteFolderToStore(parsedFolderId, folderStore);
    });
});
